const adNormSetsTabConfig = {
  tabsList: [
    {
      key: 'ad',
      label: 'Offer Sets'
    },
    {
      key: 'norm',
      label: 'norms'
    }
  ]
}
export default adNormSetsTabConfig



// WEBPACK FOOTER //
// ./src/app/configuration/ComcastOffer/config/components/generic/AdNormSetsTab.js